import { createStore } from '../utils';

import type { ReactNode } from 'react';

export type ToastInStore = {
  id: number;
  title: string;
  text?: ReactNode;
  duration: number;
};

export const toastsStore = createStore<ToastInStore[]>([]);
